import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "deals" }
const _hoisted_2 = { class: "deals__title" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { class: "deals__tabs" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  style: {"flex":"1"}
}
const _hoisted_10 = { class: "deals__tab-icon deals__tab-icon--all" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "deals__tab deals__tab--all",
  style: {"background":"none","border":"none"}
}
const _hoisted_13 = { class: "switcher" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "deals__wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "filter"
}
const _hoisted_17 = { class: "deals-filter deals-filter--open" }
const _hoisted_18 = { class: "filters" }
const _hoisted_19 = {
  class: "form",
  id: "deals-form"
}
const _hoisted_20 = { class: "form-block form-block--20" }
const _hoisted_21 = { class: "form-block form-block--20" }
const _hoisted_22 = { class: "form-block form-block--20" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "form-block form-block--20" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "form-block form-block--20" }
const _hoisted_27 = { class: "form-block form-block--20" }
const _hoisted_28 = { class: "pay-method" }
const _hoisted_29 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_30 = { class: "form-block form-block--20" }
const _hoisted_31 = { class: "form-block form-block--20" }
const _hoisted_32 = { class: "checkbox" }
const _hoisted_33 = { for: "roundedToTakerSum" }
const _hoisted_34 = { class: "form-block form-block--20" }
const _hoisted_35 = { class: "checkbox" }
const _hoisted_36 = { for: "onlyMir" }
const _hoisted_37 = { class: "form-block form-block--20" }
const _hoisted_38 = { class: "checkbox" }
const _hoisted_39 = { for: "has_dispute" }
const _hoisted_40 = { class: "form-block form-block--20" }
const _hoisted_41 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_42 = { class: "form-block form-block--20" }
const _hoisted_43 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_44 = { class: "form-block form-block--20" }
const _hoisted_45 = { class: "form-block form-block--20" }
const _hoisted_46 = { class: "form-block form-block--20" }
const _hoisted_47 = {
  key: 0,
  class: "form-block form-block--20"
}
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "form__controls" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderPayoutLimitBanner = _resolveComponent("TraderPayoutLimitBanner")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_DealsSection = _resolveComponent("DealsSection")!
  const _component_PayoutSettingsPopup = _resolveComponent("PayoutSettingsPopup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('labels.deals')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["deals__tab deals__tab--cash-in deals__tab--item", {'deals__tab--active': _ctx.currentTab === 'in'}]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setTab('in')), ["prevent"]))
        }, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "deals__tab-icon deals__tab-icon--cash-in" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M9.99989 3C10.1988 3 10.3896 3.07902 10.5302 3.21967C10.6709 3.36032 10.7499 3.55109 10.7499 3.75L10.7499 14.388L14.7099 10.23C14.7773 10.1557 14.859 10.0956 14.9501 10.0534C15.0411 10.0112 15.1398 9.98771 15.2401 9.98432C15.3404 9.98093 15.4404 9.99771 15.5341 10.0337C15.6278 10.0696 15.7133 10.124 15.7856 10.1937C15.8579 10.2633 15.9155 10.3467 15.955 10.439C15.9945 10.5313 16.015 10.6306 16.0154 10.7309C16.0158 10.8313 15.996 10.9307 15.9573 11.0233C15.9186 11.1159 15.8616 11.1998 15.7899 11.27L10.5399 16.77C10.4699 16.8426 10.386 16.9003 10.2933 16.9398C10.2005 16.9792 10.1007 16.9995 9.99989 16.9995C9.89907 16.9995 9.79929 16.9792 9.70651 16.9398C9.61373 16.9003 9.52985 16.8426 9.45989 16.77L4.20989 11.27C4.13814 11.1998 4.08121 11.1159 4.04247 11.0233C4.00374 10.9307 3.98398 10.8313 3.98438 10.7309C3.98478 10.6306 4.00532 10.5313 4.04479 10.439C4.08425 10.3467 4.14184 10.2633 4.21414 10.1937C4.28644 10.124 4.37199 10.0696 4.4657 10.0337C4.55941 9.99771 4.65939 9.98093 4.7597 9.98432C4.86002 9.98771 4.95863 10.0112 5.0497 10.0534C5.14077 10.0956 5.22245 10.1557 5.28989 10.23L9.24989 14.388L9.24989 3.75C9.24989 3.55109 9.3289 3.36032 9.46956 3.21967C9.61021 3.07902 9.80097 3 9.99989 3Z",
                fill: "#00A3FB"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('direction.in')), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["deals__tab deals__tab--payment deals__tab--item", {'deals__tab--active': _ctx.currentTab === 'out'}]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setTab('out')), ["prevent"]))
        }, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "deals__tab-icon deals__tab-icon--payment" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.0001 17C9.8012 17 9.61044 16.921 9.46979 16.7803C9.32913 16.6397 9.25011 16.4489 9.25011 16.25L9.25012 5.612L5.29012 9.77C5.22268 9.84434 5.14101 9.9044 5.04993 9.9466C4.95886 9.9888 4.86025 10.0123 4.75993 10.0157C4.65962 10.0191 4.55964 10.0023 4.46593 9.96633C4.37221 9.93037 4.28667 9.87597 4.21437 9.80635C4.14207 9.73672 4.08448 9.65329 4.04502 9.56101C4.00555 9.46872 3.98501 9.36945 3.98461 9.26907C3.98421 9.1687 4.00397 9.06927 4.0427 8.97667C4.08144 8.88407 4.13837 8.80019 4.21012 8.73L9.46012 3.23C9.53008 3.15741 9.61396 3.09968 9.70674 3.06024C9.79952 3.02081 9.8993 3.00048 10.0001 3.00048C10.1009 3.00048 10.2007 3.02081 10.2935 3.06024C10.3863 3.09968 10.4702 3.15741 10.5401 3.23L15.7901 8.73C15.8619 8.80019 15.9188 8.88407 15.9575 8.97667C15.9963 9.06927 16.016 9.1687 16.0156 9.26907C16.0152 9.36945 15.9947 9.46872 15.9552 9.56101C15.9157 9.6533 15.8582 9.73672 15.7859 9.80635C15.7136 9.87597 15.628 9.93037 15.5343 9.96633C15.4406 10.0023 15.3406 10.0191 15.2403 10.0157C15.14 10.0123 15.0414 9.9888 14.9503 9.9466C14.8592 9.9044 14.7776 9.84434 14.7101 9.77L10.7501 5.612L10.7501 16.25C10.7501 16.4489 10.6711 16.6397 10.5304 16.7803C10.3898 16.921 10.199 17 10.0001 17Z",
                fill: "#FE8C00"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('direction.out')), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["deals__tab deals__tab--disputes deals__tab--item", {'deals__tab--active': _ctx.currentTab === 'disputes'}]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setTab('disputes')), ["prevent"]))
        }, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "deals__tab-icon deals__tab-icon--disputes" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M8.48502 2.49488C9.15802 1.32788 10.842 1.32788 11.515 2.49488L17.795 13.3699C18.468 14.5369 17.625 15.9949 16.279 15.9949H3.72002C2.37302 15.9949 1.53102 14.5369 2.20502 13.3699L8.48502 2.49488ZM10 4.99988C10.1989 4.99988 10.3897 5.0789 10.5303 5.21955C10.671 5.3602 10.75 5.55097 10.75 5.74988V9.24988C10.75 9.44879 10.671 9.63956 10.5303 9.78021C10.3897 9.92086 10.1989 9.99988 10 9.99988C9.8011 9.99988 9.61034 9.92086 9.46969 9.78021C9.32903 9.63956 9.25002 9.44879 9.25002 9.24988V5.74988C9.25002 5.55097 9.32903 5.3602 9.46969 5.21955C9.61034 5.0789 9.8011 4.99988 10 4.99988ZM10 13.9999C10.2652 13.9999 10.5196 13.8945 10.7071 13.707C10.8947 13.5194 11 13.2651 11 12.9999C11 12.7347 10.8947 12.4803 10.7071 12.2928C10.5196 12.1052 10.2652 11.9999 10 11.9999C9.7348 11.9999 9.48045 12.1052 9.29291 12.2928C9.10537 12.4803 9.00002 12.7347 9.00002 12.9999C9.00002 13.2651 9.10537 13.5194 9.29291 13.707C9.48045 13.8945 9.7348 13.9999 10 13.9999Z",
                fill: "#FF4747"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('deals.tab.dispute')), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["deals__tab deals__tab--all deals__tab--item", {'deals__tab--active': _ctx.currentTab === 'all'}]),
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setTab('all')), ["prevent"]))
        }, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "deals__tab-icon deals__tab-icon--all" }, [
            _createElementVNode("svg", {
              width: "16",
              height: "17",
              viewBox: "0 0 16 17",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0.239972 5.3001C0.312195 5.36708 0.396905 5.41918 0.489265 5.45342C0.581625 5.48766 0.679825 5.50337 0.778257 5.49966C0.87669 5.49594 0.973427 5.47288 1.06294 5.43177C1.15246 5.39067 1.233 5.33233 1.29997 5.2601L3.24997 3.1601V11.7501C3.24997 11.949 3.32899 12.1398 3.46964 12.2804C3.61029 12.4211 3.80106 12.5001 3.99997 12.5001C4.19888 12.5001 4.38965 12.4211 4.5303 12.2804C4.67095 12.1398 4.74997 11.949 4.74997 11.7501V3.1601L6.69997 5.2601C6.76695 5.33233 6.84749 5.39065 6.93701 5.43175C7.02652 5.47285 7.12326 5.49592 7.22169 5.49963C7.32012 5.50335 7.41832 5.48764 7.51068 5.4534C7.60303 5.41916 7.68775 5.36707 7.75997 5.3001C7.8322 5.23312 7.89053 5.15258 7.93163 5.06306C7.97273 4.97355 7.99579 4.87681 7.99951 4.77838C8.00322 4.67995 7.98751 4.58175 7.95327 4.4894C7.91904 4.39704 7.86695 4.31232 7.79997 4.2401L4.54997 0.740098C4.47976 0.664369 4.39467 0.603955 4.30003 0.56264C4.20539 0.521325 4.10324 0.5 3.99997 0.5C3.89671 0.5 3.79455 0.521325 3.69991 0.56264C3.60527 0.603955 3.52018 0.664369 3.44997 0.740098L0.199972 4.2401C0.13299 4.31232 0.0808907 4.39703 0.0466498 4.48939C0.0124089 4.58175 -0.00330305 4.67995 0.000411383 4.77838C0.00412582 4.87682 0.0271938 4.97355 0.068298 5.06307C0.109402 5.15259 0.167737 5.23313 0.239972 5.3001ZM8.23997 11.7001C8.16774 11.7671 8.1094 11.8476 8.0683 11.9371C8.02719 12.0266 8.00413 12.1234 8.00041 12.2218C7.9967 12.3202 8.01241 12.4184 8.04665 12.5108C8.08089 12.6032 8.13299 12.6879 8.19997 12.7601L11.45 16.2601C11.5202 16.3358 11.6053 16.3962 11.6999 16.4376C11.7946 16.4789 11.8967 16.5002 12 16.5002C12.1032 16.5002 12.2054 16.4789 12.3 16.4376C12.3947 16.3962 12.4798 16.3358 12.55 16.2601L15.8 12.7601C15.9352 12.6142 16.007 12.4206 15.9995 12.2218C15.992 12.023 15.9058 11.8354 15.76 11.7001C15.6141 11.5648 15.4205 11.4931 15.2217 11.5006C15.0229 11.5081 14.8352 11.5942 14.7 11.7401L12.75 13.8401V5.2501C12.75 5.05119 12.671 4.86042 12.5303 4.71977C12.3896 4.57912 12.1989 4.5001 12 4.5001C11.8011 4.5001 11.6103 4.57912 11.4696 4.71977C11.329 4.86042 11.25 5.05119 11.25 5.2501V13.8401L9.29997 11.7401C9.233 11.6679 9.15246 11.6095 9.06294 11.5684C8.97343 11.5273 8.87669 11.5043 8.77826 11.5005C8.67982 11.4968 8.58162 11.5125 8.48927 11.5468C8.39691 11.581 8.31219 11.6331 8.23997 11.7001Z",
                fill: "#4F5965"
              })
            ])
          ], -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('labels.all')), 1)
        ], 2),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.currentTab === 'out')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "deals__tab deals__tab--all",
                style: {"background":"none","border":"none"},
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showPayoutSettings && _ctx.showPayoutSettings(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: require(`@/apps/public/assets/img/menu/settings.svg`)
                  }, null, 8, _hoisted_11)
                ])
              ]))
            : _createCommentVNode("", true),
          (['in','out'].includes(_ctx.currentTab) && (_ctx.isTrader || _ctx.isTraderOperator))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createElementBlock("label", {
                    class: "switch",
                    title: `${_ctx.helper.trans(_ctx.autoRefresh ? 'labels.auto_refresh.on' : 'labels.auto_refresh.off')}`
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.autoRefresh) = $event)),
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAutoRefresh && _ctx.toggleAutoRefresh(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.autoRefresh]
                    ]),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "slider" }, null, -1))
                  ], 8, _hoisted_14)), [
                    [
                      _directive_b_tooltip,
                      void 0,
                      void 0,
                      {
                        hover: true,
                        left: true
                      }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.currentTab === 'out' && _ctx.payoutLimit)
        ? (_openBlock(), _createBlock(_component_TraderPayoutLimitBanner, {
            key: 0,
            limit: _ctx.payoutLimit
          }, null, 8, ["limit"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.currentTab === 'all')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("form", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "ID",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.id) = $event)),
                        onKeydown: _cache[8] || (_cache[8] = _withKeys(() => _ctx.applyFilters(), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.requestDTO.id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Multiselect, {
                        id: "types",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.types,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                        options: Object.values(_ctx.Direction),
                        "custom-label": (opt) => _ctx.$t(`direction.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.$t('labels.type')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onKeydown: _cache[10] || (_cache[10] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                        placeholder: _ctx.$t('labels.from_sum'),
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestDTO.fromTakerSum) = $event)),
                        class: "form-control"
                      }, null, 40, _hoisted_23), [
                        [_vModelText, _ctx.requestDTO.fromTakerSum]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onKeydown: _cache[12] || (_cache[12] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                        placeholder: _ctx.$t('labels.to_sum'),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestDTO.toTakerSum) = $event)),
                        class: "form-control"
                      }, null, 40, _hoisted_25), [
                        [_vModelText, _ctx.requestDTO.toTakerSum]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_Multiselect, {
                        id: "currencies",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.currencies,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                        options: _ctx.currencyList,
                        "custom-label": (opt) => `${opt}`,
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.$t('labels.currencies')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Multiselect, {
                        id: "methods",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.methods,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                        options: _ctx.methodList(),
                        "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.payment_methods')
                      }, {
                        option: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_PayMethodIcon, {
                              "icon-class": "icon",
                              method: props.option
                            }, null, 8, ["method"]),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_Multiselect, {
                        id: "options",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.options,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                        options: _ctx.store.getters['currencyMethods/options'](),
                        "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.payment_options')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "roundedToTakerSum",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.requestDTO.roundedToTakerSum) = $event)),
                          "true-value": "1000"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.requestDTO.roundedToTakerSum]
                        ]),
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('labels.rounded_to_1000')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "onlyMir",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.requestDTO.onlyMir) = $event)),
                          "true-value": "y"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.requestDTO.onlyMir]
                        ]),
                        _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.only_mir_cards')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "has_dispute",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requestDTO.hasDisputeRequest) = $event)),
                          "true-value": "y"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.requestDTO.hasDisputeRequest]
                        ]),
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.helper.trans('labels.has_dispute')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_DatePicker, {
                        modelValue: _ctx.requestDTO.fromDate,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                        mode: "dateTime",
                        "model-modifiers": {string: true},
                        is24hr: "",
                        masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                      }, {
                        default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                          _createElementVNode("input", {
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('labels.from_date'),
                            value: inputValue,
                            onFocus: togglePopover,
                            onChange: inputEvents.change
                          }, null, 40, _hoisted_41)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_DatePicker, {
                        modelValue: _ctx.requestDTO.toDate,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                        mode: "dateTime",
                        "model-modifiers": {string: true},
                        is24hr: "",
                        masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                      }, {
                        default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                          _createElementVNode("input", {
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('labels.to_date'),
                            value: inputValue,
                            onFocus: togglePopover,
                            onChange: inputEvents.change
                          }, null, 40, _hoisted_43)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_Multiselect, {
                        id: "statuses",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.statuses,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                        options: Object.values(_ctx.DealStatus),
                        "custom-label": (opt) => _ctx.helper.trans(`deal_status.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.statuses')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_DevicesMultiselect, {
                        ref: "deviceMultiselect",
                        multiple: true,
                        modelValue: _ctx.devicesFilter,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.devicesFilter) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onKeydown: _cache[24] || (_cache[24] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                        placeholder: "User ID",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.requestDTO.takerId) = $event)),
                        class: "form-control"
                      }, null, 544), [
                        [_vModelText, _ctx.requestDTO.takerId]
                      ])
                    ]),
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            onKeydown: _cache[26] || (_cache[26] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                            placeholder: _ctx.helper.trans('labels.requisitesOrHolder'),
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.requestDTO.requisites) = $event)),
                            class: "form-control"
                          }, null, 40, _hoisted_48), [
                            [_vModelText, _ctx.requestDTO.requisites]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_LoaderButton, {
                        "on-click": _ctx.applyFilters,
                        class: "form__btn btn"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('button.apply')), 1)
                        ]),
                        _: 1
                      }, 8, ["on-click"]),
                      _createVNode(_component_LoaderButton, {
                        "on-click": _ctx.clearFilters,
                        class: "form__btn form__btn--reset btn btn--2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('button.reset')), 1)
                        ]),
                        _: 1
                      }, 8, ["on-click"])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DealsSection, {
          ref: "dealsSection",
          "payout-limit": _ctx.payoutLimit,
          onPayoutLimitChanged: _ctx.loadPayoutLimit
        }, null, 8, ["payout-limit", "onPayoutLimitChanged"])
      ])
    ]),
    _createVNode(_component_PayoutSettingsPopup, { ref: "payoutSettingsPopup" }, null, 512)
  ], 64))
}